import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { chatImage } from '@anytag/shared-assets';
import { SectionWithHeader, SectionWithHeaderProps } from '@anytag/shared-molecules';
import { NoDataContentWrapper, RenderDataWithFallback, NoDataContentWrapperProps } from '@anytag/shared-atoms';
import { NoteAggregateLastThirtyDays } from '../../shared';

export interface InfluencerProfilePostsOverviewWrapperProps<T = unknown>
  extends Omit<SectionWithHeaderProps, 'children'>,
    Pick<NoDataContentWrapperProps, 'dataNotAvailable' | 'wrapperText'> {
  data?: T | null;
  loading?: boolean;
  className?: string;
  children?: ReactNode | ((props: { data: T }) => ReactNode);
}

export const InfluencerProfilePostsOverviewWrapper = <T,>({
  help,
  data,
  loading,
  children,
  className,
  wrapperText,
  moreDetailProps,
  dataNotAvailable,
  ...restProps
}: InfluencerProfilePostsOverviewWrapperProps<T>) => {
  const { t } = useTranslation();

  const hasNoData = dataNotAvailable ?? !data;

  return (
    <div className={cn('mt-4', className)}>
      <RenderDataWithFallback loading={loading}>
        <SectionWithHeader
          title={t('Engagement Insights')}
          prefixIcon={chatImage}
          headerChildren={<NoteAggregateLastThirtyDays />}
          moreDetailProps={!hasNoData ? moreDetailProps : undefined}
          {...restProps}
        >
          <NoDataContentWrapper dataNotAvailable={hasNoData} wrapperText={wrapperText}>
            {!data ? null : typeof children === 'function' ? children({ data }) : children}
          </NoDataContentWrapper>
        </SectionWithHeader>
      </RenderDataWithFallback>
    </div>
  );
};
